import React from 'react';
import Page from '../../layout/Page';
import WashBundles from './WashBundles';
import WashBundleSettings from './WashBundleSettings';
import { userRoles } from '../../RoleProtected';

const KioskBundles = ({ ...props }) => {

    return (
        <Page
            title='Kiosk Bundles'
            icon='coins'
            tabs
        >
            <WashBundles tab='Bundles' />
            <WashBundleSettings tab='Settings' roles={userRoles.viewProducts} />
        </Page>
    );
}

export default KioskBundles;
